export function structureFormatter(dealStructure): string {
  let result: string =
    dealStructure &&
    dealStructure
      .filter(({ par, putPar }) => par || putPar)
      .map(({ year, putPar }) => (putPar ? `${year}(p)` : year))
      .join(', ');
  if (!result || result === '') {
    result = '-';
  }
  return result;
}
